import { combineSlices, configureStore } from '@reduxjs/toolkit';

import { authActions, reducer as authReducer } from './features/Auth/authSlice';
import { reducer as employeeReducer } from './features/Employee/EmployeeSlice';
import { reducer as filterReducer } from './features/FilterPanelSlice/filterPanelSlice';
import { reducer as periodSelectorReducer } from './features/PeriodSelector/periodSelectorSlice';
import { reducer as themeReducer } from './features/ThemeProvider/slice';
import { reducer as workLogReducer } from './features/worklog/worklogSlice';
import { busmanApiSlice } from './services/busmanApi/busmanApiSlice';

const rootReducer = combineSlices(
  {
    auth: authReducer,
    theme: themeReducer,
    employee: employeeReducer,
    worklogs: workLogReducer,
    filterPanel: filterReducer,
    periodSelector: periodSelectorReducer,
  },
  busmanApiSlice,
);

export const appReducer = (state: Parameters<typeof rootReducer>[0], action: Parameters<typeof rootReducer>[1]) => {
  if (action.type === authActions.resetCredentials.type) {
    state = undefined;
  }
  return rootReducer(state, action);
};

export const store = configureStore({
  reducer: appReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(busmanApiSlice.middleware),
  devTools: true,
});

export { rootReducer };

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
